module.exports = __webpack_public_path__ + "static/media/bonarka06.e4017d14.jpg";